import React, { useState, useRef } from 'react'; // Import useRef
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select'; // Corrected import
import MenuItem from '@mui/material/MenuItem'; // Corrected import
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import './Home.css';

const Home = () => {
    const [isDropdownOpen, setDropdownOpen] = useState(false);
    const [step, setStep] = useState(1);
    const formRef = useRef(null);
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        whatHurts: '',
        otherDetails: '',
        diagnosis: '',
        diagnosisDetails: '',
        insurance: '',
        postOperation: '',
        postOpDetails: '',
        script: ''
    });
    const [formSubmitted, setFormSubmitted] = useState(false);

    const toggleDropdown = () => {
        setDropdownOpen(!isDropdownOpen);
        formRef.current.scrollIntoView({ behavior: 'smooth' });
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const sendEmail = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch('/api/send-email', { // Updated endpoint
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                console.log('Email sent successfully!');
                setFormSubmitted(true);
            } else {
                const errorData = await response.json();
                console.error('Failed to send email:', errorData.message);
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const resetForm = () => {
        setFormData({
            name: '',
            phone: '',
            email: '',
            whatHurts: '',
            otherDetails: '',
            diagnosis: '',
            diagnosisDetails: '',
            insurance: '',
            postOperation: '',
            postOpDetails: '',
            script: ''
        });
        setStep(1);
        setDropdownOpen(false);
        setFormSubmitted(false);
    };

    const nextStep = () => setStep((prevStep) => prevStep + 1);
    const prevStep = () => setStep((prevStep) => prevStep - 1);

    return (
        <div className="container" style={{ fontFamily: 'Verdana, Geneva, sans-serif', fontSize: '20px' }}>
            <div className="header-container">
                <img src='/images/MountainCyclist.jpg' alt="Mountain Cyclist" className="parallax-image" />
                <button className="header-text" onClick={toggleDropdown} style={{ fontFamily: 'Roboto', fontSize: '40px', fontWeight: 'bold' }}>
                    Experience the Fritz Difference!
                </button>
            </div>
            <div className="verbiage-container">
                <h2 style={{ fontSize: '26px' }}>Welcome to Fritz Physical Therapy</h2>
                <p>
                    At Fritz Physical Therapy, we are dedicated to helping you achieve a pain-free life.
                    Our team of experienced professionals is here to provide personalized care and support to meet your unique needs. 
                    Whether you're recovering from an injury, managing a chronic condition, or looking to improve your overall wellness, we are here to help you every step of the way.
                </p>
            </div>
            <div ref={formRef} className="form-container">
                <div className="form-holder">
                    {!formSubmitted ? (
                        <>
                            <div style={{ textAlign: 'center', fontSize: '32px', fontWeight: 'bold' }}>
                                Can we help you live a pain-free life? Answer the questions below!
                            </div><br/>
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <Button variant='contained' onClick={toggleDropdown} style={{ fontSize: 15, height: 50, borderRadius: '10px' }} sx={{ backgroundColor: '#883001', '&:hover': {backgroundColor: '#5B1F00'} }}>
                                    Get Scheduled Today!
                                </Button>
                            </div>
                            {isDropdownOpen && (
                                <div className="form-box"> 
                                    <button className="reset-button" onClick={resetForm}>Reset</button> {/* Ensure reset button is visible */}
                                    <form onSubmit={sendEmail} className="formQuest">
                                        <br/>
                                        {step === 1 && (
                                            <div>
                                                <FormControl fullWidth>
                                                    <TextField name="name" label="Name" variant="outlined" onChange={handleChange} value={formData.name} />
                                                </FormControl>
                                                <FormControl fullWidth>
                                                    <TextField name="phone" label="Phone Number" variant="outlined" onChange={handleChange} value={formData.phone} />
                                                </FormControl>
                                                <FormControl fullWidth>
                                                    <TextField name="email" label="Email" variant="outlined" onChange={handleChange} value={formData.email} />
                                                </FormControl>
                                                <div className="button-container">
                                                    <Button variant="contained" size="medium" onClick={nextStep}>Next</Button>
                                                </div>
                                            </div>
                                        )}
                                        {step === 2 && (
                                            <div>
                                                <FormControl fullWidth>
                                                    <InputLabel>What hurts?</InputLabel>
                                                    <Select name="whatHurts" onChange={handleChange} value={formData.whatHurts}>
                                                        <MenuItem value="shoulder">Shoulder</MenuItem>
                                                        <MenuItem value="knee">Knee</MenuItem>
                                                        <MenuItem value="back">Back</MenuItem>
                                                        <MenuItem value="neck">Neck</MenuItem>
                                                        <MenuItem value="ankle">Ankle</MenuItem>
                                                        <MenuItem value="elbow">Elbow</MenuItem>
                                                        <MenuItem value="wrist">Wrist</MenuItem>
                                                        <MenuItem value="hip">Hip</MenuItem>
                                                        <MenuItem value="other">Other</MenuItem>
                                                    </Select>
                                                </FormControl>
                                                {formData.whatHurts === "other" && (
                                                    <FormControl fullWidth>
                                                        <TextField
                                                            label="Please specify what hurts"
                                                            variant="outlined"
                                                            name="otherDetails"
                                                            onChange={handleChange}
                                                            value={formData.otherDetails}
                                                            multiline
                                                            rows={4}
                                                        />
                                                    </FormControl>
                                                )}
                                                <div className="button-container">
                                                    <Button variant="contained" size="medium" color="error" onClick={prevStep}>Back</Button>
                                                    <Button variant="contained" size="medium" onClick={nextStep}>Next</Button>
                                                </div>
                                            </div>
                                        )}
                                        {step === 3 && (
                                            <div>
                                                <div>
                                                    <FormControl fullWidth>
                                                        <InputLabel>Have you received a diagnosis?</InputLabel>
                                                        <Select name='diagnosis' onChange={handleChange} value={formData.diagnosis}>
                                                            <MenuItem value='no'>No</MenuItem>
                                                            <MenuItem value='yes'>Yes</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                    {formData.diagnosis === 'yes' && (
                                                        <TextField 
                                                            label="Please specify your diagnosis" 
                                                            variant="outlined" 
                                                            name='diagnosisDetails' 
                                                            onChange={handleChange} 
                                                            value={formData.diagnosisDetails} 
                                                            fullWidth 
                                                            multiline 
                                                            rows={4} 
                                                        />
                                                    )}
                                                </div>
                                                <div className="button-container">
                                                    <Button variant='contained' size='medium' color='error' onClick={prevStep}>Back</Button>
                                                    <Button variant='contained' size='medium' onClick={nextStep}>Next</Button>
                                                </div>
                                            </div>
                                        )}
                                        {step === 4 && (
                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px', backgroundColor:'rgb(223, 223, 223)', padding: '20px', border: '1px solid rgb(196, 196, 196)', borderRadius: '10px', width: '100%' }}>
                                                    <TextField label="What insurance do you have?" variant="outlined" name='insurance' onChange={handleChange} value={formData.insurance} fullWidth multiline rows={4} />
                                                    <p style={{ fontSize: '14px', color: 'red', textAlign: 'center', marginTop: '10px' }}>
                                                        <strong>Note:</strong> We do <u>NOT</u> accept Gateway or UPMC (except for UPMC For Life).
                                                    </p>
                                                    <div className="button-container">    
                                                        <Button variant='contained' size='medium' color='error' onClick={prevStep}>Back</Button>
                                                        <Button variant='contained' size='medium' onClick={nextStep}>Next</Button>
                                                    </div>
                                                </div>  
                                            </div>
                                        )}
                                        {step === 5 && (
                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px', backgroundColor: 'rgb(223, 223, 223)', padding: '20px', border: '1px solid rgb(196, 196, 196)', borderRadius: '10px', width: '100%' }}>
                                                    <FormControl fullWidth>
                                                        <InputLabel>Are you post-operation?</InputLabel>
                                                        <Select name='postOperation' onChange={handleChange} value={formData.postOperation}>
                                                            <MenuItem value='no'>No</MenuItem>
                                                            <MenuItem value='yes'>Yes</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                    {formData.postOperation === 'yes' && (
                                                        <TextField 
                                                            label="Please specify your operation" 
                                                            variant="outlined" 
                                                            name='postOpDetails' 
                                                            onChange={handleChange} 
                                                            value={formData.postOpDetails} 
                                                            fullWidth 
                                                            multiline 
                                                            rows={4} 
                                                        />
                                                    )}
                                                    <div className="button-container">
                                                        <Button variant='contained' size='medium' color='error' onClick={prevStep}>Back</Button>
                                                        <Button variant='contained' size='medium' onClick={nextStep}>Next</Button>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        {step === 6 && (
                                            <div>
                                                <div>
                                                    <FormControl fullWidth>
                                                        <InputLabel>Did you receive a script to come here?</InputLabel>
                                                        <Select name='script' onChange={handleChange} value={formData.script}>
                                                            <MenuItem value='no'>No</MenuItem>
                                                            <MenuItem value='yes'>Yes</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                                <div className="button-container">
                                                    <Button variant='contained' size='medium' color='error' onClick={prevStep}>Back</Button>
                                                    <Button variant='contained' size='medium' color='success' type="submit">Submit</Button>
                                                </div>
                                            </div>
                                        )}
                                    </form>
                                </div>
                            )}
                        </>
                    ) : (
                        <div className="Submitted">
                            <div className="pre-appointment-info">
                            <h2>Thank you for submitting the form!</h2>
                            <p>Print and fill out the New Patient Registration Form below, and bring it with you to your first visit along with your insurance information and photo ID.</p>
                            <a href="/forms/Patient-Intake-Form-Fritz-PT.pdf" download>
                                <Button variant='contained' size='medium' style={{ margin: '10px', padding: '10px 20px', fontSize: '16px', borderRadius: '5px' }} sx={{ backgroundColor: '#883001', '&:hover': {backgroundColor: '#5B1F00'} }}>
                                    Download New Patient Registration Form
                                </Button>
                            </a>
                            <h3>Before Your First Visit</h3>
                            </div>
                            <ul>
                                <li>Make a list of questions that you have to discuss on your first visit.</li>
                                <li>List signs and symptoms that can be of importance to the physical therapist.</li>
                                <li>Have in writing key past medical history, previous treatments, current medications, and other important information.</li>
                                <li>Please call our office to verify your insurance benefits.</li>
                                <li>Arrive 15 minutes early for your first appointment.</li>
                                <li>Bring with you a copy of your insurance card and a photo ID.</li>
                            </ul>
                            <div className="pre-appointment-info">
                            <h3>What to Expect on Your First Visit</h3>
                            </div>
                            <ul>
                                <li>You will register with our friendly front office staff. They will help you navigate the insurance process and treatment program so you can focus on your recovery.</li>
                                <li>You will meet with your physical therapist for the initial new patient evaluation.</li>
                                <li>During the evaluation your physical therapist will ask questions about your medical history, current pain, or injury. we want to have as open of communication as possible to ensure we help you heal.</li>
                                <li>You will be evaluated on several different metrics, like strength and mobility. We want to help you so if something hurts please tell your physical therapist during the evaluation.</li>
                                <li>Your physical therapist will use their world class knowledge to assess and then reccomed a treatment plan customized to your needs. Please ask questions!</li>
                                <li>The first day will not be the full treatment plan, we want to get you into the swing of things!.</li>
                                <li>You can then schedule your necessary following appointments with the front desk at the end of the first appointment. </li>
                                <li>Your physical therapist will then document your case for further medical professional needs.</li>
                                <li>If you have any questions at anytime, please don’t hesitate to call. We want to ensure your satisfaction and full recovery.</li>
                            </ul>
                        </div>
                    )}
                </div>
            </div>

            <div className="verbiage-container">
                <p className="awarded-verbiage" style={{ fontWeight: 'bold', fontSize: '24px' }}>
                    Awarded the “Best Physical Therapy Practice” by the Pittsburgh Tribune Review for 2014.
                </p>
            </div>

            <div className="verbiage-container">
                <h2 style={{ fontSize: '26px' }}>What Makes Us Different?</h2>
                <p>
                    Here at Fritz Physical Therapy & Sports Medicine we strive to give you world class outpatient care. With over two decades of service to our community we ensure that you feel like the Most Valuable Patient when you are here!
                </p>
                <ul style={{ textAlign: 'left' }}>
                    <li style={{ marginBottom: '5px' }}>One on One Care, When you are here you are the focus!</li>
                    <li style={{ marginBottom: '5px' }}>Positive Experience Guarantee, We want you to go back to living your life!</li>
                    <li style={{ marginBottom: '5px' }}>State-of-the-art Equipment, We use the latest technology to aid your recovery!</li>
                    <li style={{ marginBottom: '5px' }}>Highly Trained Staff, Our team is continuously trained to provide the best care!</li>
                    <li style={{ marginBottom: '5px' }}>Personalized Treatment Plans, Each plan is tailored to your specific needs!</li>
                    <li style={{ marginBottom: '5px' }}>Convenient Scheduling, We offer flexible hours to fit your busy life!</li>
                </ul>
            </div>
            <div className="map-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px', padding: '20px', margin: '0 auto', maxWidth: '80%' }}>
                <div className="google-map" style={{ flex: 1, maxWidth: '30%', margin: '0 auto' }}>
                    <div style={{ width: '100%', height: '100%', borderRadius: '15px', overflow: 'hidden', border: '2px solid rgb(177, 177, 177)', boxShadow: '5px 5px 10px rgba(0, 0, 0, 0.3)', margin: '10px auto' }}>
                        <iframe title="iframe" width="100%" height="100%" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?width=100%25&amp;height=100%25&amp;hl=en&amp;q=501https://www.google.com/maps/place/Fritz+Physical+Therapy+%26+Sports+Medicine+-+Collier+Town+Square/@40.4000617,-80.0831508,17z/data=!3m1!4b1!4m6!3m5!1s0x8834f7e2d67cd9c9:0x74236db8f0a96fce!8m2!3d40.4000617!4d-80.0831508!16s%2Fg%2F1tk1nn76?entry=ttu&g_ep=EgoyMDI1MDIwMi4wIKXMDSoASAFQAw%3D%3D%20N%203rd%20St,%20Harrisburg%20PA%2017120+(Pennsylvania%20State%20Capitol%20Complex)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed">
                            <a href="https://www.gps.ie/">gps handsets</a>
                        </iframe>
                    </div>
                </div>
                <div className="verbiage-container" style={{ flex: 1, maxWidth: '50%', fontSize: '20px', textAlign: 'center', marginLeft: '5px' }}>
                    Located in the heart of Carnegie on Washington Avenue we service you the greater Pittsburgh area. Chartiers Valley, South Fayette, Carlynton, Upper Saint Clair, Mt. Lebo, and any Pittsburgher who wants to receive the best treatment!
                </div>
            </div>
        </div>
    )
}

export default Home;